// Copyright 2026 Zibby Lab. Apache-2.0.
//
// LogLine — one row of a log viewer, shared by the apps container-logs tab
// and the workflow logs tab so highlighting is identical: a severity stripe
// (amber WARN / red ERROR), an optional level badge, a dimmed timestamp, a
// bright message and a dimmed body.
//
// Presentational only — callers pass an already-parsed line (see
// parseLogLine / parseLogPayload). Styling lives in the shared `.app-logs-*`
// rules (AppDetailPage.css), which are bundled app-wide.

import React from 'react';
import PropTypes from 'prop-types';

export default function LogLine({
  lineNo, gutterWidth = 3, ts, level, msg, body, severity = 'info',
}) {
  return (
    <div className={`app-logs-line app-logs-line--${severity}`}>
      {lineNo != null && (
        <span className="app-logs-lineno" style={{ width: `${gutterWidth}ch` }}>
          {lineNo}
        </span>
      )}
      <span className="app-logs-linetext">
        {ts && <span className="app-logs-ts">{ts}</span>}
        {level && (
          <span className={`app-logs-level app-logs-level--${String(level).toLowerCase()}`}>
            {level}
          </span>
        )}
        {msg && <span className="app-logs-msg">{msg}</span>}
        {body && <span className="app-logs-body-txt">{body}</span>}
      </span>
    </div>
  );
}

LogLine.propTypes = {
  lineNo: PropTypes.number,
  gutterWidth: PropTypes.number,
  ts: PropTypes.string,
  level: PropTypes.string,
  msg: PropTypes.string,
  body: PropTypes.string,
  severity: PropTypes.oneOf(['info', 'warn', 'error']),
};
